

export default cjs;
import packageResult from 'utils/packageResult';
import { req } from 'utils/mappers';
function cjs(bundle, options) {
	var importBlock = bundle.externalModules.map(function (x) {
		return 'var ' + x.name + ' = ' + req(x.id) + ';';
	}).join('\n');

	if (importBlock) {
		bundle.body.prepend(importBlock + '\n\n');
	}

	var defaultName = bundle.entryModule.identifierReplacements['default'];
	if (defaultName) {
		bundle.body.append('\n\nmodule.exports = ' + defaultName + ';');
	}

	if (options.useStrict !== false) {
		bundle.body.prepend("'use strict';\n\n").trimLines();
	}

	return packageResult(bundle, bundle.body, options, 'toCjs', true);
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/builders/defaultsMode/cjs.js.01-babel.map